<ng-template #confirmationTemplate>
  <div class="modal-header">
    <h5 class="modal-title">{{ options.title }}</h5>
    <button
      class="btn-close btn-close--sm"
      aria-label="Close"
      (click)="onCancel()"
    ></button>
  </div>
  <div class="modal-body">
    {{ options.content }}
  </div>
  <div class="modal-footer">
    <button class="btn btn-sm btn-secondary" (click)="onCancel()">
      <span class="icon c-btn__icon c-btn__iconImage">
        <i class="iconFont iconFont-close"></i>
      </span>
      <span class="c-btn__title">{{ options?.cancelButtonText }}</span>
    </button>
    <button class="btn btn-sm btn-danger" (click)="onConfirm()">
      <span class="icon c-btn__icon c-btn__iconImage">
        <i class="iconFont iconFont-check"></i>
      </span>
      <span class="c-btn__title">{{ options?.confirmButtonText }}</span>
    </button>
  </div>
</ng-template>
